import SvgIcon from '@material-ui/core/SvgIcon';

export default function ArrowUpIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M7 23 l10 0 l0 -12 l5 0 l-10 -10 l-10 10 l5 0z"></path>
        </SvgIcon>
    );
}
